import React from 'react';

import { useUserContext } from '../../context/UserContext';
import TodayEmptyStateView from '../to-do/TodayEmptyStateView';

const TodayEmptyStateScreen: React.FC = () => {
  const { user } = useUserContext();

  return <TodayEmptyStateView />;
};

export default TodayEmptyStateScreen;
